import { ReceivablesAnticipationActions } from "../actions";

const initialState = {
  receivablesAnticipationGeneralInformation: null,
  receivablesAnticipation: {
    rows: [],
    rowCount: 1,
    pageCount: 1,
  },
};

export default function receivablesAnticipation(state = initialState, action) {
  switch (action.type) {
    case ReceivablesAnticipationActions.ACTION_SAVE_RECEIVABLES_ANTICIPATION_GENERAL_INFORMATION:
      return {
        ...state,
        receivablesAnticipationGeneralInformation: action.payload,
      };
    case ReceivablesAnticipationActions.ACTION_SAVE_RECEIVABLE_ANTICIPATION:
      return {
        ...state,
        receivablesAnticipation: action.payload,
      };
    default:
      return state;
  }
}

export function getReceivablesAnticipationGeneralInformation(state) {
  return state.receivablesAnticipation
    .receivablesAnticipationGeneralInformation;
}

export function getReceivablesAnticipation(state) {
  return state.receivablesAnticipation.receivablesAnticipation;
}
